import { ISpecialist, IDeveloper } from '../../../types/specialist';

/* istanbul ignore next */
export const developerMapper = ({
  name,
  detailFullUrl,
  logoFullUrl,
  offersCount,
  newobjectsCount,
}: IDeveloper): ISpecialist => ({
  id: name,
  url: detailFullUrl,
  imageUrl: logoFullUrl,
  title: name,
  offersCount,
  newobjectsCount,
});
